import React from 'react';

interface MessageBoxProps {
  icon: string;
  message: string;
}

const MessageBox: React.FC<MessageBoxProps> = ({ icon, message }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8">
      <div className="text-center">
        <div className="mb-6">
          <i className={`${icon} text-gray-800`} style={{fontSize: '3rem'}}></i>
        </div>
        <p className="text-gray-700 mb-4">
          {message}
        </p>
      </div>
    </div>
  );
};

export default MessageBox;

